import {
  Box, Button, styled,
} from '@mui/material';
import { scrollbarStyle2 } from '../../../../../styles/scrollbarStyles';
import { sanguine, spaceCadet, ultraMarine } from '../../../../../utils/colors';

const StyledBox = styled(Box)(({ theme }) => ({
  ...scrollbarStyle2,

  maxWidth: '100%',
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width'], { duration: theme.transitions.duration.short }),
  width: 270,
  overflowX: 'hidden',
  overFlowY: 'auto',
  minWidth: 0,
  height: '100%',
  backgroundColor: spaceCadet[100],
  padding: 0,
  borderRadius: '6px 0 0 6px',
  display: 'flex',
  flexDirection: 'column',

  '& hr': {
    borderBottomWidth: 2,
  },

  '& a,.MuiButtonBase-root.link': {
    color: spaceCadet[500],
    fontSize: 16,
    lineHeight: '20px',
    textDecoration: 'none',
    display: 'flex',
    gap: 6,
    alignItems: 'center',
    '& svg': {
      fontSize: 'inherit',
      display: 'block',
    },
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  '& .grow': {
    flexGrow: 1,
  },

  '& .MuiBox-root.content': {
    padding: '8px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    alignItems: 'flex-start',

    '& .MuiBadge-root': {
      '& .MuiBadge-badge': {
        top: '6px',
        left: 2,
        right: 'auto',
        backgroundColor: sanguine[500],
      },
      '& .MuiTypography-root.version': {
        marginLeft: 20,
      },
    },
    '& .MuiTypography-root.version': {
      fontSize: 12,
      lineHeight: '12px',

      '& .MuiButtonBase-root': {
        marginLeft: 8,
        cursor: 'pointer',
        color: ultraMarine[500],
        fontSize: 12,
        lineHeight: '12px',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
  },
}));

export default StyledBox;

export const MenuButton = styled(Button)({
  backgroundColor: 'transparent',
  textTransform: 'none',
  textAlign: 'left',
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: 14,
  lineHeight: '20px',
  padding: '6px 8px',
  color: spaceCadet[700],
  whiteSpace: 'nowrap',
  '& .current-micro': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& svg': {
      marginRight: 8,
    },
    '& p': {
      width: 170,
      height: 20,
      fontSize: 14,
      lineHeight: '20px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '& .disabled': {
      color: sanguine[500],
    },
  },
  '& p': {
    fontSize: 14,
    lineHeight: '20px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
  },
  '&.current': {
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
    },
  },
});
